import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CustomCurrencyPipe } from '@shared/pipes/custom-currency.pipe';
import { SiteSettingsService } from '@shared/services/site-settings.service';
import { CurrencyEnum } from '@shared/shared/enums/currency.enum';
import { ISiteSettings } from '@shared/shared/interfaces/site-settings.interfaces';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'price-on-card',
  templateUrl: './price-on-card.component.html',
  styleUrls: ['./price-on-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CustomCurrencyPipe, NgIf, TranslateModule],
})
export class PriceOnCardComponent {
  @Input() public valueProposition: string;
  @Input() public prefix: string;
  @Input() public suffix: string;

  public readonly CurrencyEnum = CurrencyEnum;

  public currency: string;
  public customFromSymbol: string;

  constructor(private siteSettingsService: SiteSettingsService) {
    this.siteSettingsService
      .fetchSiteSettings()
      .pipe(
        filter((siteSettings: ISiteSettings) => !!siteSettings && !!siteSettings.id),
        take(1)
      )
      .subscribe((siteSettings: ISiteSettings) => {
        this.currency = siteSettings.currency;

        if (siteSettings.language.startsWith('zh')) {
          this.customFromSymbol = 'SimplifiedTraditionalChineseCarHotelPriceSymbol:From';
        }
      });
  }
}
